// @flow

import React from "react"

export default () => <span className="middot"> &middot; </span>
